export type UTMTags = {
  utmSource: string | undefined;
  utmMedium: string | undefined;
  utmCampaign: string | undefined;
  utmTerm: string | undefined;
  utmContent: string | undefined;
};

export function getUTMTagsFromURL(): UTMTags {
  const urlParams = new URL(window.location.href).searchParams;
  function getQueryParam(paramName: string): string | undefined {
    const val = urlParams.get(paramName);
    return val === null ? undefined : val;
  }
  return {
    utmSource: getQueryParam("utm_source"),
    utmMedium: getQueryParam("utm_medium"),
    utmCampaign: getQueryParam("utm_campaign"),
    utmTerm: getQueryParam("utm_term"),
    utmContent: getQueryParam("utm_content"),
  };
}

export function emptyToUndefined(x: string | undefined): string | undefined {
  return x === "" ? undefined : x;
}
